import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import GenericGuideVideoBlockData from '../../../Models/Content/GenericGuideVideoBlockData';
import GenericGuideVideo from './GenericGuideVideoBlock';

export default class GenericGuideVideoBlock extends EpiComponent<GenericGuideVideoBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['generic-guide-video-block'];

    return (
      <div className={cssClasses.join(" ")}>
            <GenericGuideVideo iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}

